import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Facebook, Twitter, Instagram } from "lucide-react";

type FooterSectionProps = {
  visible?: boolean;
};

export default function FooterSection({ visible = true }: FooterSectionProps) {
  const navigate = useNavigate();
  const handleGoBack = useCallback(() => {
    navigate("/product-finder");
  }, [navigate]);
  return (
    <footer
      className={`fixed bottom-0 left-0 z-50 w-full bg-black text-white transition-all duration-300 flex items-center justify-between px-6 py-3
      ${visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"}`}
    >
      {/* This stays on the LEFT */}
      <div
        className="font-semibold"
        title="Regent-Lighting-Asia-Private-Limited"
      >
        <span className="flex gap-4">
          <img
            src="https://www.regent.ch/fileadmin/main/images/logo_white.svg"
            alt="logo"
            width={100}
            height={30}
            onClick={handleGoBack}
            className="object-contain cursor-pointer"
          />
          Regent Lighting Asia Private Limited
        </span>
      </div>

      <div className="flex gap-10 pr-20">
        <div className="cursor-pointer hover:text-blue-400" title="facebook">
          <a
            href="https://www.facebook.com/regentlightingasia"
            target="_blank"
            rel="noreferrer"
          >
            <Facebook size={18} />
          </a>
        </div>
        <div
          className="cursor-pointer hover:text-blue-300"
          title="Twitter"
          rel="noreferrer"
        >
          <a href="https://x.com/regent_asia" target="_blank">
            <Twitter size={18} />
          </a>
        </div>
        <div className="cursor-pointer hover:text-pink-400" title="Instagram">
          <a
            href="https://www.instagram.com/regent_asia/"
            target="_blank"
            rel="noreferrer"
          >
            <Instagram size={18} />
          </a>
        </div>
      </div>
    </footer>
  );
}
